/**
 * Page name constants for navigation stack tracking
 * Used to identify pages in the pageStack for conditional UI logic
 */
export const PAGE_NAME_CONSTANTS = {
  COMMON_LANDING: "COMMON_LANDING",
  LANDING: "LANDING",
  LISTING: "LISTING",
  TRAVELLER_DETAILS: "REVIEW", // TravellerDetails page maps to REVIEW in analytics
  ORDER_CONFIRMED: "THANK_YOU_POLICY", // OrderConfirmed maps to THANK_YOU_POLICY
  ORDER_DETAILS: "ORDER_DETAILS",
  ADD_PASSPORT: "ADD_PASSPORT",
  ORDER_LISTING: "ORDER_LISTING",
  DOWNLOAD_POLICY: "ORDER_DETAILS", // DownloadPolicy is accessed from OrderDetails
  EDIT_TRAVELLERS: "REVIEW", // EditTravellerDetails is part of review flow
} as const;

export type PageName =
  typeof PAGE_NAME_CONSTANTS[keyof typeof PAGE_NAME_CONSTANTS];
